module.exports = __webpack_public_path__ + "img/mamo-banner.fe385527.png";